import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { classes } from './styles';
import DashboardNavBar from '../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../components/Dashboard/Common/SidebarMenu';

const DashboardPage = () => {
  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.mainPageContainer}>
        <Typography variant="subtitle1" component="div">
          Welcome to the Admin Dashboard for LHCF. Click on any menu from the
          left sidebar to get started.
        </Typography>
      </Box>
    </Box>
  );
};

export default DashboardPage;
